import { render, staticRenderFns } from "./BsaContent.vue?vue&type=template&id=4c8e4684"
import script from "./BsaContent.vue?vue&type=script&lang=js"
export * from "./BsaContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c8e4684')) {
      api.createRecord('4c8e4684', component.options)
    } else {
      api.reload('4c8e4684', component.options)
    }
    module.hot.accept("./BsaContent.vue?vue&type=template&id=4c8e4684", function () {
      api.rerender('4c8e4684', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/bsa/BsaContent.vue"
export default component.exports